<template>
    <!--div class="navegacao" v-show="ds"-->
     <v-row >
          <v-dialog v-model="ds" :fullscreen="check_for_fullscreen()"  overlay-color="black" persistent transition="dialog-bottom-transition" >
        <!--v-navigation-drawer v-model="ds" fixed  temporary right width="100%" overlay-color="black"-->
            <v-list-item style="background-color:#efefef" >
                <v-list-item-content>
                <v-list-item-title color="black"><b>Adicionar/Editar Faixa</b></v-list-item-title>          
                </v-list-item-content>
                <v-btn @click="emitSalvar()"  small elevation="0" outlined color="primary">
                    Continuar depois
                </v-btn>
            </v-list-item>
            <v-list-item style="padding:0px;">
               
                <v-stepper
                    v-model="e1"
                    :alt-labels="altLabels"
                    vertical                   
                    class="elevation-0"
                >
                    <template>
                        <template v-for="n in steps">
                            <v-stepper-step
                            
                            :key="`${n}-step`"
                            :complete="e1 > n"
                            :step="n"
                            :editable="true"
                            >
                            {{ stepName [n - 1] }}
                            </v-stepper-step>

                            <v-stepper-content
                            :key="`${n}-content`"
                            :step="n"
                            pt-0
                            >                            
                            
                            <!--- STEP 1 -->
                            <v-flex v-if="n==1" class="mb-6">
                                
                                <v-layout d-inline-flex wrap>
                                    <v-flex xs12 sm12 md5 pr-4 align-self-center> 
                                        <p class="body-2 "> A obra é a letra da música. Cadastre primeiro a obra dessa música. Em seguida selecione ela na faixa ao lado para essa faixa.</p>                                                
                                    </v-flex>

                                    <v-flex xs12 sm12 md7>
                                        <v-select
                                            v-model="trackItem.works"
                                            :items="$store.getters.obras"
                                            label="Obras da faixa"
                                            item-text="name"
                                            item-value="id"
                                            clearable
                                            outlined
                                            multiple
                                            return-object
                                            messages="Selecione uma ou mais obras, que você já cadastrou,  para fazer as faixas. Se tiver dúvidas clique no ícone (?)"
                                            v-validate="'required'"

                                            :error-messages="errors.collect(`faixa${indiceTrack}.obras`)"
                                            :data-vv-name="`faixa${indiceTrack}.obras`"                                                   
                                            :id="`faixa${indiceTrack}.obras`"
                                            required 
                                            
                                            append-outer-icon="help_outline"
                                            @click:append-outer="help('product_track_work')"
                                            @change="track_work_changed"
                                            @click:clear="track_work_changed"
                                        >
                                            <template v-slot:prepend-item>
                                                <v-list-item
                                                    style="border-bottom:1px solid #e0e0e0; width:100%; text-align:center"
                                                    text-center
                                                    :to="{name:'work_add'}"
                                                >
                                                    <v-list-item-content
                                                        style="color:green;justify-content: center;"
                                                    >
                                                        <v-icon
                                                            color="green"
                                                            style="flex:none!important"
                                                        >add</v-icon>&nbsp;&nbsp;ADICIONAR OBRA
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </template>

                                            <template v-slot:selection="data">
                                                <v-chip
                                                    :input-value="data.selected"
                                                    close
                                                    @click:close="removeObra(trackItem, data.item)"
                                                    @click="removeObra(trackItem, data.item)"
                                                >
                                                    <strong>{{ data.item.name }}</strong>&nbsp;
                                                </v-chip>
                                            </template>
                                        </v-select>
                                    </v-flex>
                                    <!-- Nome da Faixa -->
                                    <v-flex xs12 md12 style="padding:5px;">
                                    <v-text-field
                                        class="purple-input text-capitalize"
                                        label="Nome da faixa"
                                        :error-messages="errors.collect(`faixa${indiceTrack}.track_name`)"
                                        :data-vv-name="`faixa${indiceTrack}.track_name`"                                             
                                        v-validate="'required'"
                                        messages="O nome da faixa é o mesmo da obra da faixa."
                                        outlined
                                        disabled
                                        v-model="trackItem.name"
                                        append-outer-icon="help_outline"
                                        @click:append-outer="help('product_track_name')"
                                    />
                                </v-flex>
                                <v-flex xs12>
                                    <v-btn                                    
                                    @click="nextStep(n)"                                    
                                    :disabled="trackItem.works.length === 0"
                                    class="mt-12 white--text" 
                                    color="green"                                 
                                    depressed
                                >                                    
                                    Continue 
                                </v-btn>
                                </v-flex>
                                </v-layout>                                
                                
                            </v-flex>

                            <!--- STEP 2 -->
                            <v-flex v-if="n==2" style="padding:5px;margin-bottom:0px">
                                <v-layout wrap>
                                    <v-flex xs12 sm8 md4 pr-3>
                                        <!--:disabled="(track.is_playback==1)"-->
                                        <v-select
                                            v-model="trackItem.isrc_info.type"
                                            :items="fonograma_tipo"
                                            label="Tipo de gravação"
                                            item-text="name"
                                            item-value="id"
                                            outlined
                                            messages="Selecione o tipo que melhor caracterize onde essa música foi gravada."
                                            
                                            :error-messages="errors.collect(`faixa${indiceTrack}.tipo_gravacao`)"
                                            
                                            :data-vv-name="`faixa${indiceTrack}.tipo_gravacao`"                                                            
                                            v-validate="'required'"
                                            
                                            append-outer-icon="help_outline"
                                            @click:append-outer="help('product_track_isrc_infotype')"
                                        ></v-select>
                                    </v-flex>

                                    <v-flex xs12 sm8 md4 pr-3>
                                        <v-select
                                            v-model="trackItem.is_playback"
                                            :items="[{name:'SIM',val:1},{name:'NÃO',val:0}]"
                                            label="Playback?"
                                            item-text="name"
                                            item-value="val"
                                            messages="Essa música tem apenas instrumental e backvocal?"
                                            outlined
                                            
                                            @change="track_work_changed"

                                            :error-messages="errors.collect(`faixa${indiceTrack}.is_playback`)"
                                            :data-vv-name="`faixa${indiceTrack}.is_playback`"                                                                                                                      
                                            v-validate="'required'"                                                          
                                        ></v-select>
                                    </v-flex>

                                    <v-flex xs12 sm8 md4 pr-3>
                                        <v-select
                                            :disabled="trackItem.is_playback==1"
                                            v-model="trackItem.is_instrumental"
                                            :items="[{name:'SIM',val:1},{name:'NÃO',val:0}]"
                                            label="Instrumental?"
                                            item-text="name"
                                            item-value="val"
                                            messages="Essa música é apenas instrumental, não contendo voz e nem backvocal?"
                                            outlined
                                            
                                            :error-messages="errors.collect(`faixa${indiceTrack}.is_instrumental`)"
                                            :data-vv-name="`faixa${indiceTrack}.is_instrumental`"     
                                            v-validate="'required'"
                                        ></v-select>
                                    </v-flex>
                                </v-layout>                                                              
                                <v-btn
                                    class="mt-12 white--text" 
                                    color="green"                                 
                                    depressed
                                    @click="nextStep(n)"                                    
                                    :disabled="(trackItem.is_playback == null && trackItem.is_instrumental==null) || (trackItem.is_playback == null || trackItem.is_instrumental==null)"
                                >                                    
                                    Continue 
                                </v-btn>
                            </v-flex>

                            <!--- STEP 3 -->
                            <v-flex v-if="n==3" persistent style="width:100%">
                                <v-layout wrap >
                                    <v-flex  xs12 >
                                        
                                        <v-row align-content="center" align="center">           
                                            <v-col cols="12" class="body-2 ">
                                                Participação/Feat é quando uma ou mais pessoas cantam junto com você nessa faixa.<br>Para dar os devidos créditos adicione as informações dela(s).                                                
                                            </v-col>
                                            <v-col cols="12" sm="12" md="6">                                 
                                            <v-select
                                                v-model="trackItem.feat_artists"
                                                :items="trackItem.feat_artists"
                                                outlined
                                                hide-selected
                                                :search-input.sync="search"
                                                hint="Adicione o nome do(s) artista(s) que participaram dessa música com você."
                                                label="Participação Especial / Featuring Artists (feat) "
                                                multiple
                                                persistent-hint
                                                chips
                                                deletable-chips                                                                
                                                item-text="alias"
                                                return-object
                                            >
                                                <template v-slot:no-data>
                                                    <v-list-item>
                                                    <v-list-item-content>
                                                        <v-list-item-title>
                                                        Sem artistas, clique em<b> adicionar Participação/Feat</b>
                                                        </v-list-item-title>
                                                    </v-list-item-content>
                                                    </v-list-item>
                                                </template>
                                            </v-select>
                                         </v-col>
                                        <v-col cols="12" sm="12" md="6" >
                                            <v-btn    color="light-green darken-3" dark @click="dialog_adicionar_feat = true;"><v-icon>add</v-icon> Participação/Feat</v-btn>
                                        </v-col>
                                         
                                        </v-row>
                                    </v-flex>

                                    <v-flex my-6 md12 v-if="dialog_adicionar_feat" persistent>                                       
                                        <v-card elevation="0" style="border:1px solid #999">
                                            <v-card-title>
                                            <span class="headline">Adicionar Participação/Feat</span>
                                            </v-card-title>
                                            <v-card-text>
                                            
                                                <v-row>           
                                                    <v-col cols="12">
                                                        <v-text-field 
                                                            label="Nome artístico/Pseudônimo" 
                                                            v-model="dialog_feat_obj.alias"
                                                            outlined
                                                            tabindex="1"
                                                        ></v-text-field>
                                                    </v-col>

                                                    <v-col cols="12">
                                                        <v-text-field 
                                                            label="Nome completo" 
                                                            v-model="dialog_feat_obj.fullname"
                                                            outlined
                                                            tabindex="2"
                                                                
                                                        ></v-text-field>
                                                    </v-col>

                                                    <v-col cols="12" >
                                                        <v-text-field
                                                            v-model="dialog_feat_obj.br_cpf_cnpj"						
                                                            outlined
                                                            label="CPF"
                                                            v-mask="'###.###.###-##'"
                                                            tabindex="3"
                                                            
                                                        ></v-text-field>
                                                    </v-col>
                                                </v-row>
                                            
                                            <small>todos os campos são obrigatórios</small>
                                            </v-card-text>
                                            <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="red darken-1" small outlined @click="dialog_adicionar_feat = false; dialog_feat_obj={}">Cancelar</v-btn>
                                            <v-btn color="blue darken-1" small outlined @click="adicionar_feat_to_track()">Adicionar</v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-flex>                    

                                    
                                <v-flex xs12>
                                    <v-btn                                    
                                        @click="nextStep(n)"
                                        class="mt-12 white--text" 
                                        color="green"                                 
                                        depressed
                                    >                                    
                                        Continue 
                                    </v-btn>
                                </v-flex>

                                </v-layout>
                                
                            </v-flex>

                            <!--- STEP 4 -->
                            <v-flex v-if="n==4">
                                <v-layout xs12 sm12 md12 style="margin-bottom:0px;" wrap>
                                    <v-flex xs12 sm12 md12 align-self-center>                                        
                                        <v-radio-group v-model="trackItem.own_isrc" style="margin-top:-5px;">
                                            <template v-slot:label>
                                                <div>Você tem um ISRC válido?
                                                        <v-btn
                                                            icon
                                                            @click="help('product_track_isrc')"
                                                        >
                                                            <v-icon>help_outline</v-icon>
                                                        </v-btn>
                                                </div>
                                            </template>
                                            <v-radio :value="1">
                                                <template v-slot:label>
                                                    <div>Sim, tenho.</div>
                                                </template>
                                            </v-radio>
                                            <v-radio :value="0">
                                                <template v-slot:label>
                                                    <div>Não, gostaria de adquirir um válido por R$ 42,90.</div>
                                                </template>
                                            </v-radio>
                                        </v-radio-group>
                                    </v-flex>

                                    <v-flex xs12 sm12 md8 align-self-center>
                                        <v-text-field v-if="trackItem.own_isrc == 1"
                                            class="purple-input"
                                            label="ISRC"
                                            outlined
                                            v-mask="'AA-XXX-#######'"
                                            :disabled="!is_item_disabled(trackItem.own_isrc)"
                                            messages="Registro da obra, se não tiver geraremos uma para você."
                                            v-model="trackItem.isrc"
                                            append-outer-icon="help_outline"
                                            @click:append-outer="help('product_track_isrc')"
                                            v-validate="'required|min:14|max:14'"                                                                                       
                                            :error-messages="errors.collect(`faixa${indiceTrack}.isrc`)"
                                            :data-vv-name="`faixa${indiceTrack}.isrc`"                                                                                                                   
                                        />                                                   
                                    </v-flex>
                                </v-layout> 
                                <!--v-btn           
                                    v-if="trackItem.own_isrc === 0 || (trackItem.own_isrc === 1 && trackItem.isrc && errors.items.length === 0)"                         
                                    @click="nextStep(n)"
                                    color = "pink lighten-1"
                                    dark
                                >                                    
                                    Continue 
                                </v-btn-->
                                <v-btn              
                                    class="mt-12 white--text" 
                                    color="green"                                 
                                    depressed
                                    @click="nextStep(n)"                                    
                                    :disabled="(trackItem.own_isrc === 1 && (!trackItem.isrc || errors.items.length > 0))"
                                >                                    
                                    Continue 
                                </v-btn>
                            </v-flex>

                            <!--- STEP 5 -->
                            <div v-if="n==5"> 
                            <v-flex v-if="trackItem.own_isrc==0" style="margin-bottom:00px;" xs12 md12>
                                <v-flex align-self-center>
                                    <template  v-if="(trackItem.isrc_info.participantes !=undefined && trackItem.isrc_info.participantes.length === 0)">
                                        Para gerarmos o seu ISRC corretamente precisamos de informações adicionais da sua música.
                                        <b />
                                        <v-btn
                                            v-if="trackItem.isrc_info.participantes.length === 0"
                                            @click="continuar_adicionar_informacoes_isrc(trackItem)"
                                            color="orange"
                                            dark
                                            class='target_btn_informacoes_adicionais'
                                            style="margin-top:10px;"
                                        ><v-icon>add</v-icon> informações adicionais</v-btn>&nbsp;
                                        <v-btn v-if="indiceTrack > 0 && !trackItem.isrc_info.participantes"
                                            @click="trackItem.isrc_info = trackItem.isrc_info"
                                            color="green"
                                            dark
                                        ><v-icon>file_copy</v-icon> copiar informações da faixa 1</v-btn>
                                    </template>                                                    
                                </v-flex>

                                <template
                                    v-if="(trackItem.isrc_info.participantes !=undefined && trackItem.isrc_info.participantes.length !== 0)"
                                >
                                    <v-flex style="background-color:#fafafa;padding:10px;">
                                        <v-flex t class="target_isrc_info">
                                            Você precisa inserir abaixo o nome de cada músico com o instrumento (MÚSICO ACOMPANHANTE) que tocou e pessoa que cantou (INTERPRETE) junto com você nessa faixa.
                                            <br />Caso você tenha cantado e tocado um instrumento você precisa aparecer tanto como interprete como quanto músico.
                                            <br />
                                            <br />
                                        </v-flex >
                                        <v-layout  wrap>
                                            <v-flex xs12 md5 pr-2 > 
                                                <v-select
                                                    v-model="fonograma_individuo_parcial.tipo"
                                                    :items="fonograma_categoria_pessoa"
                                                    background-color="white"
                                                    label="Atuação do participante"
                                                    item-text="cat"
                                                    item-value="cod"
                                                    return-object
                                                    outlined
                                                    messages="Categoria a qual o participante atuou nesse fonograma."
                                                    append-outer-icon="help_outline"
                                                    @click:append-outer="help('product_track_isrc_infotype')"
                                                ></v-select>
                                            </v-flex>

                                            <v-flex xs12 md7 pr-2>
                                                <v-text-field
                                                    :disabled="fonograma_individuo_parcial.tipo.cat==undefined"
                                                    background-color="white"
                                                    v-model="fonograma_individuo_parcial.fullname"
                                                    outlined
                                                    label="Nome completo"
                                                    
                                                    :hint="`Nome completo do ${fonograma_individuo_parcial.tipo.cat} selecionado.`"
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 md6 pr-2>
                                                <v-text-field
                                                    v-model="fonograma_individuo_parcial.alias"
                                                    :disabled="fonograma_individuo_parcial.tipo.cat==undefined"
                                                    outlined
                                                    label="Nome artístico/pseudônimo"
                                                    :hint="`Nome artistíco/pseudônimo do ${fonograma_individuo_parcial.tipo.cat} selecionado.`"
                                                    

                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 md6 pr-2>
                                                <v-text-field
                                                    v-model="fonograma_individuo_parcial.br_cpf_cnpj"
                                                    :disabled="fonograma_individuo_parcial.tipo.cat==undefined"
                                                    outlined
                                                    label="CPF"
                                                    v-mask="'###.###.###-##'"
                                                    
                                                ></v-text-field>
                                            </v-flex>

                                            <v-flex xs12 md8 pr-2>
                                                <v-autocomplete
                                                    v-show="fonograma_individuo_parcial.tipo.cod=='MA'"
                                                    v-model="fonograma_individuo_parcial.instrumentos"
                                                    :items="fonograma_instrumentos"
                                                    label="Instrumentos"
                                                    item-text="name"
                                                    background-color="white"
                                                    item-value="id"
                                                    outlined
                                                    small-chips
                                                    deletable-chips
                                                    multiple
                                                    @change="track_work_changed"
                                                    messages="Selecione todos os instrumentos que esse músico tocou"
                                                    
                                                    append-outer-icon="help_outline"
                                                    @click:append-outer="help('product_track_isrc_infotype')"
                                                ></v-autocomplete>
                                            </v-flex>

                                            <v-flex xs12 md4 text-right>
                                                <v-btn
                                                    color="green"
                                                    style="color:white"
                                                    :disabled="fonograma_individuo_parcial.tipo.cat == null"
                                                    @click="adicionar_participante(trackItem)"
                                                >ADICIONAR {{fonograma_individuo_parcial.tipo.cat}}</v-btn>
                                            </v-flex>
                                        </v-layout>
                                            
                                        <v-flex
                                            v-if="trackItem.isrc_info.participantes != null"
                                        >
                                            <br/>
                                            <v-divider color="#fefefe"></v-divider>
                                            <v-data-table
                                                :items-per-page="300"
                                                v-if="trackItem.isrc_info.participantes"
                                                :items="trackItem.isrc_info.participantes"
                                                :headers="[ {text:'Nome completo',value:'fullname'},
                                                            {text:'Nome artistíco/pseudônimo',value:'alias'},
                                                            {text:'CPF/CNPJ',value:'br_cpf_cnpj'},
                                                            {text:'Função',value:'tipo.cat'},
                                                            {text:'Instrumentos',value:'instrumentos'},
                                                            {text:'Ações',value:'acoes'},
                                                            ]"
                                                hide-default-footer 

                                            >
                                                <v-flex 
                                                    v-slot:item.instrumentos="{ item }"
                                                >
                                                    {{ item.instrumentos ? item.instrumentos.join(', '):''}}
                                                </v-flex>
                                                    
                                                <v-flex                                                                                                                                    
                                                    v-slot:item.acoes="{item}"
                                                    >                                                                   
                                                    <v-btn v-if="item.deletable!==false" icon small color="red" dark>
                                                        <v-icon @click="delete_participante_member(item, trackItem)">delete</v-icon>
                                                    </v-btn>&nbsp;&nbsp;

                                                    <v-btn v-if="item.deletable!==false" icon small color="green" dark>
                                                        <v-icon @click="edit_participante_member(item, trackItem)">edit</v-icon>
                                                    </v-btn>
                                                </v-flex>

                                            </v-data-table>
                                        </v-flex>
                                    </v-flex>
                                </template>
                            </v-flex>

                            <v-flex v-if="trackItem.own_isrc==1" style="margin-bottom:00px;">
                                <template>
                                    Como você já possui o seu ISRC não será necessário cadastrar informações adicionais.
                                    <br />
                                </template> 
                               
                            </v-flex>
                             <v-btn                               
                                @click="emitSalvar()"                                
                                :disabled="!(trackItem.own_isrc == 1 || (trackItem.isrc_info.participantes !=undefined && trackItem.isrc_info.participantes.length !== 0) )"
                                class="mt-12 white--text" 
                                color="green"                                 
                                depressed
                            >
                                Finalizar
                            </v-btn>
</div>

                            
                            
                            
                        </v-stepper-content>
                        </template>
                    </template>
                </v-stepper>
               
            </v-list-item>
        <!--/v-navigation-drawer-->
          </v-dialog>
        <ProductHelp ref="product_help" />

        <modalmessage
            :dialog_opened="message.dialog_opened"
            :title="message.title"
            :message="message.message"
            btn_1_text="entendi"
            @btn_1_clicked="modalmessage_entendi"
            ref="modal"
        />
    <!--/div-->
     </v-row>
</template>

<script>

import { mapGetters } from "vuex";
import Vue from "vue";
import VeeValidate from "vee-validate";
//components
import modalmessage from "../../../../components/shared/modalmessage";
import ProductService from "../../../../app/Rest/product";

import ProductHelp from "../../../../components/help/product";

import {valida_cpf} from "../../../../app/general"

import NavSteppers from "../../Products/inc/NavigationSteppers"

Vue.use(VeeValidate);
let productService = null;

export default {
    $_veeValidate: {
        validator: "new"
    },
    components: {
        modalmessage,
        ProductHelp,
        NavSteppers
    },
    props: { drawerStepper: Boolean, trackItem: Object, trackList: Array, indiceTrack: Number },
    data: () => ({
        ds: false,
        tag: null,
        e1: 1,
        steps: 5,
        vertical: true,
        altLabels: false,
        editable: true,
        stepName: ['Nome da Faixa / Obras','Gravação','Participações / Feats','ISRC','Informações Adicionais'],
        drawer: false,
        dialog_adicionar_feat:false,
        dialog_feat_obj:{},
        force_render_faixa_tabs:null,
        fonograma_individuo_parcial: { tipo: {} },
        btn_adicionar_info:false,
        fonograma_categoria_pessoa: [
            { cod: "MR", cat: "REGENTE" },
            { cod: "PL", cat: "LICENCIANTE" },
            { cod: "PF", cat: "PRODUTOR FONOGRÁFICO" },
            { cod: "I", cat: "INTERPRETE" },
            { cod: "MA", cat: "MÚSICO ACOMPANHANTE" },
            { cod: "CV", cat: "CORO / VOZ" },
            { cod: "LI", cat: "LICENCIADO" }
        ],
        fonograma_instrumentos: [
            "BERRANTE","CLARIN","CLARINETE","CLARONE","CONTRA FAGOTE","CORNE INGLES","FAGOTE","FLAUTA","FLAUTA BAIXO","FLAUTA DOCE","FLAUTA EM SOL","FLAUTIM","FLUGEL HORN","GAITA","OBOE","OCARINA","PISTON","SAX ALTO","SAX BAIXO","SAX BARITONO","SAXOFONE","SAX SOPRANO","SAX TENOR","TROMBONE BAIXO","TROMBONE PISTON","TROMBONE TENOR","TROMBONE VARA","TROMPA","TROMPETE","TROMBONE","TUBA/BOMBARDINO","SHANKER","LEAD","SHIME","GAITA DO FOLE","ALAUDE","BAIXO","BANDONEON","BANDOLIM","BANJO","CAVACO","CAVAQUINHO","CITARA","CONTRA BAIXO","CRAVO","GUITARRA SOLO","GUITARRA BASE","GUITARRA HAVAIANA","GUITARRA PORTUGUESA","BAIXOLA","HARPA","LIRA","GUNGA","VIBRAFONE","VIOLA","VIOLAO","VIOLAO 12","VIOLAO 7 CORDAS","VIOLAO ACUSTICO","VIOLINO","VIOLINO SPALLA","VIOLONCELO","STEEL GUITAR","VIOLA 10 (CAIPIRA)","LOOPINGS","VIOLAO QUINTO","VIOLAO OVATION","VIOLAO 6 CORDAS","BAIXO ELETRICO","BAIXO ACUSTICO","BATERIA","BERIMBAU","BONGO","BUMBO","CAIXA","CHOCALHO","CONGA","CUICA","GANZA","KACIMBA","MARACA","MARIMBA","PANDEIRO","PIFANO","QUEIXADA","RABECA","RECO RECO","REPINIQUE","SURDO","TABLA","TAMBOR","TAMBORIM","TAMBORINE","TANTAN","TAROL","TIMBALE/TIMBLAU","TIMPANO","TRIANGULO","TUMBADORA","XILOFONE","XIQUE XIQUE","ZABUMBA","SAMPLER","CABACA","ATABAQUE","AFOXE","BINGOLA","CASCARA","REPIQUE","DJAMBE","FACA","VARGEM","SINO","CAXIXI","CASTANHOLA","REQUINTO","DERBAK","REPIQUE DE ANEL","CATIRA","CAIXA DE FOLIA","TAMPA DE LATAO","CAIXA DE FOSFORO","REALEJO","SOCADOR","MATRACA","COQUINHO","PANDEROLA","TACO","PEDAL STEEL","ACORDEON","CLAVE (CLAVECINO)","HARMONICA","MINI MOOG","ORGAO","PIANO","PIANO ACUSTICO","SANFONA","SINTETIZADOR","BATERIA DE LATAS/GARRAFAS","PICOLO","XILOFONE DE TAMBORINS","PRATOS","BACURINHO","SINCERRO","CARRILHAO","XEQUERE","COWBELLS","TALK BOX","CHIMES","CHARANGA","UDUH","EUFONIO","TUBERE","CONTRATEMPO","PAU DE CHUVA","ENXADA","BLOCK","AGOGO","PERCUSSAO","TECLADO","METAIS","CORDAS","SOPRO","PROGRAMADOR DE BATERIA","PALMAS","MENDOLIN","PRODUCAO","BLINS","VIOLAO DE ACO","MANDOLIN","DOBRO","FLAUTA PAM","CAMA","WOOD BLOCK","CAMA VOICES","PIZZICATO","PAD","HORN","CAIXA ORQUESTRA","SCRATCHES","BATERIA ELETRONICA","BANDA","ACORDEON 8 BAIXOS","COPIAS MUSICAIS","ARREGIMENTAÇÃO BASES","PROGRAMACAO","BASS","BEAT BOX","CORDEONA","DARBUKAS","FLAUTA TRANSVERSA","GUINZO","GUIRO","KORG/KLONG","MOLO","MORINGA","MUZETTE","SYNTH BASS","TAMBOR BOI","RAP","CRYVACO","FEDDLE","PANDEIRAO","ASSOVIO","GAITA PONTO","DIRECAO MUSICAL","CONTRABAIXO ACUSTICO","RITMO","BASE ELETRONICA","NAIABINGUIM","UNHAS","COMPLEMENTOS","SHIBAL","EFEITOS ESPECIAIS","MIXAGEM","PANTAGONE","APITO","TORPEDO","GUITARRA TREMULA","RITM TECH","GONGO","PANDEIRO ABERTO","SEQUENCIA","PIANO ELETRICO","GUITARRA","VIOLAO BASE","REBOLO","SYNT PIZZICATO","VIOLAO SOLO","ARREGIMENTACAO","ESCALETA","SLIDE GUITAR","TECNICO GRAVACAO","AUXILIAR TECNICO DE GRAVACAO","POLYSIX","VIOLAO DE NYLON","CANOS DE BAMBU","BOMBO LEGUERO","LATAS","COPISTA","CHINELOFONE","LEGUEIRO","COORDENAÇAO","PANELA","WIND SYNTH","RHODES","GUITARRA BAIANA","CAJON","BANDEJA","FRIGIDEIRA","VASO","PERC-LOOPS","CRAVIOLA","ACORDEON BASE","ACORDEON SOLO","CAVACO SOLO","REPIQUE DE MAO","BAIXO SOLO","PROGRAMADOR DE TECLADO","BATERIA ACUSTICA","COLAGENS","DIREÇÃO VOCAL","BATIDAS","CALIMBA","STEEL DRUMS","SAX SOLO","VIOLAO FLAMENCO","TECLADO ELETRONICO","CUATRO VENEZOLANO","CHARANGO","QUEEA","ZAMPOEA","WASHBORD","BAIXO FRETLESS","VENTO","POLLI-SYNTH","HIGH STRING","CORO DE TECLADO","SNAP","GLOCKSPELL","PREGO","SQUASH","MARCACAO","HAMMOND XB2","CIMBAL","TUBULAR","ROADES","CELESTA","PLATINELA","LAMINA","GUITARRA ACUSTICA","XIQUERE","MIDI","GRANT BLOCK","VASSOURINHA","GONGUE","ALFAIA","BELTRY","OBEHAINE","FENDU","GARRAFAS SOPRADAS","CINCERRO","VIOLAO COM ARCO","MARIMBA DE VIDRO","VIOLAO DOBRO","LAPIS NO DENTE","VIOLA DE COCHO","NAYABINGUIM","DIRECAO DE PRONUNCIA","PROPHET","FENDER RHODES","VIOLAO ELETRICO","HI - HAT","PERCUSSAO ACUSTICA","MELLOTRON","BOMBARDINO","EFEITO VENTO","RUBBER NOSE","APITO CHAIMMANBU","CAIXA DE ISOPOR","INSTROSCUTA","TIMBANCO","QUADRICANO","ESTANTE DE TONEL","ESTANTE COM TAMPAO","FRELESS","TRASTE","GONGE","DBARK","SAMPLES","PASSAROS","CHIC","TAMPURA","ASSIST.DE PRODUCAO","MOOG","BLIM","VIOLINO SOLO","AFOUXE","ONDAS","MUSSETE","VIOLA PORTUGUESA","LOOPS","DUBLAGENS","EFEITOS SONOROS","DUBLAGEM","BAIXO SYNTH","EDICAO","CHIMBAU","FLAUTA EM DO","ELETRONIC DRUMS","PICK UPS","SAX","PIANINHO","ENV FILTER BEAT","SERROTE","ROCAR","BONBU-LEGUERO","AIR FX","BAMBU","VIOLAO10 CORDAS","LINHA DE BAIXO","RUIDO","TAMA","VOCODER","GROOVE BOX","TROMBONITO","ROCHIMBAU","PAU","TURNTABLES","TECLADO SOLO","TECLADO BASE","CELLO","ZAMPONA","FANTASIA","CARR","COBERTURA","SALTERIO","FOLE DE 8 BAIXOS","TALK DRUMS","REALISTIC","TOCA DISCOS","OCTAPAD","BOREL","DIRECAO ARTISTICA","BORDANGULO","UKELELE","AMBIENT LOVE DRUM KI","GUITARRA WA WA","EGGS","KEYBOARDS","VIBES","METROLA","BOMBO DE MACAIBA","GOUNGUE","RITINTA","BACURINHAS","CACHETA","STRINGS","TRILA","GRANDE PAN","CHORI","TECNICO DE SOM","BACK VOCAL","SPRINGER DRUM","ALUGUEL DX7","CAVACO BANDOLA","LAPIS DE BOCA","INTERFERENCIAS","VIOLA SINFONICA","DIGERIDU","BELLS","JAMBLOK","ARIANO","PROTOOLS","PANDEIRO ARABE","BILHAS MEDIA","BILHAS GRAVE","PORCA","SHAKE","TEREMIM","PHOPHET FIVE","PERCUSSAO ELETRONICA","EFEITOS DE AMBIENCIA","GRAVACAO DE VOZ","ARRANJO DE BASE","B4","PRO 53","SYNTH CRUMAR","BAIXOLAO","PIANO RHODES","ORGAO HAMMOND","BATA","ARRANJADOR - 8/001","REGENTE - 8/002","CORO 7/002","EXECUÇÃO BASE","PIANO FENDER","TIMBA","SHAIC","CARROM","LATAS E GARRAFAS","SOLISTA","FLAUTA BARROCA","DECLAMADOR","HAMMOND XB3","SEKERE","TAMBOR ONCA","TAMBOR CRIVADOR","QUINTO","CARACAXAS","E-BOW","FLAUTONETE","FLAKSTONE","NOZES","TB303","PANDEIRAO C/ VASSOURA","MORINGA C/VASSOURA","ELETRIC STAR","GUITARRA SLIDE","MANOLA","JARRO","EFEITO","LAP STEEL","ABACO","CURIMBO","OBXA","CAPUTA","OVATION","OVATION","RAGGASOUNDS","COLHER","ACIRDEID","ECOS","FLAUTA CONTRALTO","FLAUTA SOPRANO","FLAUTA TENOR","CONCERTMASTER","EFEITOS ELETRONICOS","EFEITOS INSTRUMENTAIS","SAMPLERS","PROGRAMADOR DE PERCUSSAO","CALOTAS","ARROZ","CAIXA DE CHARUTO","MAO","PORTA E CADEIRA","ESTALOS DE DEDO","LATAS DE LIXO","DJ","VIOLAO TENOR","YAKULT","PIANO YAMAHA","COBEL","MEIA LUA","CAMPANA","CHEIK","SPALLA","BUMEO","SIMONS","SIMONS","CAIXETA","SURDO-MARACANÃ","CROONER","BANDARRA","SAD MIDI","PRODUCAO ARTISTICA","GUITARRA MIDI","ACID DRUMS","MACAMBIRA","EMULATOR","MELODIA INTRODUCAO","BARITONO","CAIXA LINN ELETRONICA","TIMBALE","TIMBALE","PROGRAMADOR DE MIDIA","EFEITOS DE BRINQUEDO","BAMBUMOLA","BELL TREE","PANDEIRO TURCO","SEMENTE","PANDEIRO ITALIANO","PANDEIRO DO MARANHAO","TAMBORES MARROQUINHO","TAMBOR DE BARRO","BENDIR","GUIZOS","OCEAN DRUMS","VIDROS","BERIMBOCA","BERIMBAU DE BOCA","KOTO","TUBO ASPIRADOR","XEQUEREZINHO","VIOLAO CLASSICO","PERUS","VIOLAO 8 CORDAS","VIOLAO 8 CORDAS","TROMBONE ALTO","MASTERIZACAO","SOROBAN","CAIXA COM VAS","ZARB","SITAR","CAIXA DE CONGO","KALIMBA","MBIRA","TAMBOR DE MINA","FRAME DRUM","HAND SONIC","GUITARRA STILL","GUITARRA ESPACIAL","HARMONICOS","GONGO TIBETANO","QUARTETO DE TROMBONE","RIFS","BALDE","GUITARRA INVERTIDA","PRUMAR","PLEX (LOOP)","KAOSS PAD","ELU","POTE","CAIXA DO DIVINO","TRANSCRICAO PARA CORDAS","KISSANGE","NGOMA","JEROMA","TAMBOR DE ALFAIA","PAKAWAJ","MINEIRO","PAN INCLINADO","TIMBALES DE LATA","BOMBONAS","CHIFRES DE ANTILOPE","TIMBAUS","PRODUCAO EXECUTIVA","SURDO VIRADO","PRODUCAO MUSICAL","BATERIA DE SUCATA","BALAINHO","TRISURDO","XERES","ESTREMPE DE TAMPAS","CONGUE","TAMBOR CONDENSADOR","TAMBOR DE CONGADA","ESTREMPE DE EXTINTO","CAIXA DE PAPELAO","BALAFON","ILU","MILHEIRO","PANDEIRO DE NYLON","CANECA","JUNO 60","CORDAS SYNTH","MANGUEIRA","CILINDRO","BICICLETA","CHAMINE","CADEIRA","TRIPE DE MEIO","VASSOURA","GONGUE DE FERRO","CHIMBARRALO","SYNTHS","MACONDERE","UMTHINGO","XIZAMBI","SININHOS","GUAIA","TAMBU","PANDEIROLA","BOMBINHO","NAVE","CAIXA CABACA","BADALO","ABOIO","CATOLICO","MARACATU","HARDCORE","MARFIM","SURDO DE MEIO","SURDO DE FUNDO","BANDENEON","FLAUTA SOLO","GEROMA","CHAPA DE METAL","TRILOBITA","BANSURI","VIOLACHO","COCO","OUTROS","INSTRUMENTAL","RONCADOR","RALADOR DE COCO","UKULELE","GUITARRA SITAR","RUM DE AQUERE","NABUA","NAVESTIL","DEDEDRUMM","PEDALEIRA DE EFEITOS","RONTONTON","BIT BEATRIZ","DARBUCA","VERGALHÃO","OVINHO","TON-TONS","FARFISA","KASRIEL","ANIMACAO","ALECTRAVIBE","TEMAMETAIS","VOX","CRIVADOR","MEIAO","RETINTAS","TAMBURITOS","FINGERCLAP","JOMBLOCK","ENGENHEIRO DE GRAVACAO","ENGENHEIRO DE MIX","RÓTULO","BOUZOUK","GUITARRON","PANDEIRO CAJON","FLAUTA INDIA"
        ],
        fonograma_tipo: [
            "STUDIO","LIVE (AO VIVO)","REMIX","UNPLUGGED (ACUSTICO)","STUDIO","VINHETA","CLUB REMIX","HOUSE EDIT","TAPE","EXTENDED MIX","LONG VERSION","RADIO REMIX","VHS","A CAPELA","SURTO","ALBUM","ROCK VERSION","ACUSTICO AO VIVO","RADIO EDIT","GROOVE MIX","R&B MIX","G-VO MIX","DRUM N BASS","R&B CLASSIC","G-VO COOL MIX","VO MIX","POP MIX","RADIO HIT MIX","D&B X-PERIENCE MIX","EDITED SLOW","RADIO VERSION","RADIO MIX","EDIT MIX","DVD","ACUSTICO MTV","VERSAO DJ HUM","MIX","STUDIO VERSION","MTV AO VIVO","PLAY BACK","AFOXE","AFOX","LOUNGE MIX","VERSAO DUB","ACUSTICO","XRS REMIX RADIO EDIT","MEME SUPER CLUB MIX 2002","INSTITUTO MIX","BIBLIOTECA","TRILHA","NI"
        ],
        tab: null,
        search:null,
        release_date: null,
        tem_upc: false,
        moved_track_order: false,
        editable_product: null,
        audio_files: [],
        input_selected: null,
        cover: null,
        cover_file: null,
        sending_cover_loading: false,
        item_cover: null,
        panel_expanded: [0, 1, 2],
        modal: false,
        image_size: {},
        tmp_release_data: null,
        product: {
            type: "",
            record_label_name: "Nova Música Gospel",
            release_date: null,
            own_upc: 0
        },
        platforms: [],
        message: {
            dialog_opened: false,
            title: "",
            message: "",
            btn_1_text: ""
        },
        product_type_choosed: {},

        //dicionário de validação
        dictionary: {
            messages:{
                required:'Esse campo é obrigatório',
                min: 'ISRC incompleto'
            },
            attributes:{
                tipo_gravacao:'Tipo gravação'
            },
            custom: {
                is_instrumental: {
                    required: "Se essa é pra ser somente instrumental?"
                },
                tipo_gravacao: {
                    required: "Precisamos saber se você gravou em estúdio, acustivo, ao vivo ...."
                },
                is_playback: {
                    required: "Marque 'SIM' somente se essa faixa inteira não tem a voz principal."
                },
                product_name: {
                    required: "O título do produto é bem importante, hein!"
                },
                type: {
                    required: "O formato do produto é obrigatório"
                },
                track_name: {
                    required: "O nome da faixa é obrigatório"
                },
                obras: {
                    required:
                        "É necessário ao menos uma obra vinculada a esse fonograma"
                },
                release_date: {
                    required:
                        "Data de lançamento é obrigatório, mesmo que seja para uma data no passado."
                },
                copyright_year: {
                    required: "Ano de copyright é obrigatório."
                },
                copyright: {
                    required: "Copyright do Produto é obrigatório."
                },
                copyright_phonogram: {
                    required: "Copyright da Gravação é obrigatório."
                }
            }
        }
    } ),
    
    mounted() {
        this.$validator.localize("ptbr", this.dictionary);
        if (this.$store.getters.obras.length == 0) {
            this.$refs.modal.show({
                title: "Você não tem nenhuma OBRA MUSICAL cadastrada.",
                message: "Você precisa ter pelo menos <b>uma</b> obra musical para poder montar e distribuir seu Single, EP ou Álbum",
                btn_1_text: "CADASTRAR DEPOIS",
                btn_2_text: "CADASTRAR AGORA",
                btn_2_action: () => {
                    return this.$router.push({ name: "work_add" });
                }
            });
        }
    },
    computed: {
        ...mapGetters(["configs", "artist"]),
        min_date_datepicker:function(){
            //20 dias de espera
            return new Date(new Date().getTime()+(20*24*60*60*1000)).toISOString();
        },
        formated_date: function() {
            return this.formatDate(this.release_date);
        },
        page_title() {
            if (this.product.id) {
                return (
                    "EDITANDO" +
                    (!this.$vuetify.breakpoint.smAndUp
                        ? ""
                        : " > " + this.product.name)
                );
            } else {
                return "NOVO PRODUTO";
            }
        },
        plataformas() {
            return this.configs.platforms.filter(e => {
                if (["content_match", "streaming"].indexOf(e.type) >= 0) {
                    return true;
                }
                return false;
            });
        },
        computed_cover() {
            if (this.product.thumbnail) {              
                return (this.product.thumbnail.indexOf("googleapis")>=0) ? this.product.thumbnail : process.env.VUE_APP_BASE_URL + this.product.thumbnail;
            } else if (this.thumbnail != null) {
                return this.thumbnail;
            } else {
                return false;
            }
        }
    },
    beforeCreate: function() {
        return;
        productService = ProductService.build();

        if (this.$route.params)
            this.editable_product =
                this.$route.params.id == undefined
                    ? false
                    : this.$route.params.id;

        if (!this.editable_product) {
            return;
        }

        this.$store.dispatch("loading_full");
        productService
            .getOne(this.editable_product)
            .then(e => {
                if (e.items) {
                    this.product = e.items.product;
                    this.update_tracks_info(e.items.trackList);
                    this.cover = this.product.thumbnail;

                      //renderiza as abas se forem maior que 1, ajuda na validação
                    //@todo remover daqui
                    if(this.trackList.length>1 && this.force_render_faixa_tabs ==null){
                        var tmp = this.indiceTrack;

                        this.trackList.map( (e,o)=>{
                            setTimeout( ()=>{
                                this.indiceTrack = (this.trackList.length -1) - o;                            
                            },300);
                        });
                        this.force_render_faixa_tabs = true;
                    }        
                    
                } else {
                    this.$store.dispatch("loading_full", false);
                    this.$refs.modal.show({
                        title: "Não encontrado",
                        message: "O produto buscado não foi encontrado",
                        btn_1_text: "Entendi",
                        btn_1_action: () => {
                            this.$router.push({ name: "products" });
                        }
                    });
                }
            })
            .finally(() => {
                this.$store.dispatch("loading_full", false);
               
            });
    },
    created() {
        this.platforms = this.plataformas.map(e => {
            return e.id;
        });
    },
    watch: {
        trackList: {
            handler: function(s, n) {
               
            },
            deep: true
        },       
        drawerStepper (drawerStepper) {
            this.ds = drawerStepper
        }
    },
    methods: {
        nextStep (n) {
            if (n === this.steps) {
                this.e1 = 1
            } else {
                this.e1 = n + 1
            }
        },
        emitSalvar () {
            this.emitClose()
            this.$emit('emit-salvar')
        },
        emitClose() {
            this.$emit('emit-close', true)
        },        
        //adicionar obra
        //@todo remover
        click_modal_btn_2() {
            return this.$router.push({ name: "work_add" });
        },
        help(tag) {
            this.$refs.product_help.show(tag);
        },                
        removeObra(faixa, item) {
                        
            faixa.works.splice(faixa.works.indexOf(item), 1);
            faixa.works = [...faixa.works];
            this.track_work_changed();
           
        },
        modalmessage_entendi() {
            this.message.dialog_opened = false;
        },
        
        alerta_ajuda(item) {
            alert("olaaaaaa " + item);
        },
        check_for_fullscreen(){
            
            return this.$vuetify.breakpoint.smAndDown;
        }
        ,
        update_tracks_info(_tracks) {
            //manter o estado atual dos arquivos
            var _audiofiles = [];
            //this.audio_files = [];
            if(_tracks == undefined){
                return ;
            }

            this.trackList = _tracks.map(rr => {

                let _trk = this.audio_files.filter(e => {
                    if (e.track_id == rr.id) {
                        return true;
                    }
                    return false;
                });

                //se o audio_file já estiver definido, mantemos o estado atual dele.
                if (_trk.length > 0) {
                    _audiofiles.push(_trk[0]);
                } else {
                    //indicamos aqui o push
                    _audiofiles.push({
                        audio_file: rr.audio_path,
                        state: rr.audio_path ? "uploaded" : "nofile",
                        track_id: rr.id,
                        progress: 0
                    });
                }

                if (!rr.isrc_info || rr.isrc_info == null || rr.isrc_info == '""') {
                    rr.isrc_info = {};
                }else{
                   if( typeof(rr.isrc_info) =="string"){
                        rr.isrc_info = JSON.parse( rr.isrc_info);
                        if(typeof(rr.isrc_info) == "string"){
                            rr.isrc_info = JSON.parse( rr.isrc_info);
                        }
                    }
                }
                
                if(rr.feat_artists == undefined || rr.feat_artists == "" || rr.feat_artists == '""'){
                    
                    rr.feat_artists = [];
                }else{
                    if( typeof(rr.feat_artists) =="string"){
                        rr.feat_artists = JSON.parse( rr.feat_artists);
                        if( typeof(rr.feat_artists) =="string"){
                            rr.feat_artists = JSON.parse( rr.feat_artists);
                        }
                    }
                }
                return rr;
            });

            this.panel_expanded = this.trackList.map((e, i) => {
                return i + 1;
            });
            this.audio_files = _audiofiles;
        },      
        
        track_work_changed() {
           let _t = this.trackItem;
           if(_t.works.length==0){
               _t.name = "";
               return;
           }
           let _wks = _t.works.map( e=>{
               return this.$store.getters.obras.filter( ee=>{  return e.id == ee.id })[0];
           });
           
           
           _t.name = _wks.map(e=>{return e.name}).join(" / ");
           if(_t.is_playback){
               _t.name = _t.name + " (Playback)"
               //se é playback, automaticamente o is_instrumental é não
               _t.is_instrumental = 0;
           }
        },     
        
        is_item_disabled(val) {
            return val ? true : false;
        },
        adicionar_participante(track) {
            let fip = this.fonograma_individuo_parcial;
            
            //----------------------------------------
            //-------- VALIDAÇÃO DOS CAMPOS ----------
            //----------------------------------------
            var erro_isrc = null;
             if(fip.br_cpf_cnpj =="" || fip.br_cpf_cnpj == undefined ){
               
                erro_isrc = "O CPF é um campo obrigatório.";                
            }
        
            if(fip.alias =="" || fip.alias == undefined){
               
                erro_isrc = "O nome artístico/pseudônimo é obrigatório.";                
            }
            if(fip.fullname =="" || fip.fullname == undefined){
               
                erro_isrc = "O nome completo do participante é obrigatório.";                
            }
            if(fip.tipo.cod=="MA"){
                if( fip.instrumentos == undefined || fip.instrumentos.length == 0){
                    erro_isrc = "Para músico acompanhante é necessário selecionar ao menos UM instrumento.";
                }
            }           
            if(erro_isrc!=null){
                 this.$refs.modal.show(
                    "Informações do ISRC",
                    erro_isrc,
                    "Entendi"
                );
                return;
            }
            valida_cpf(fip.br_cpf_cnpj.replace(".","").replace("-","")).then(e=>{               
                if(e.valid){
                    track.isrc_info.participantes.push(
                        JSON.parse(JSON.stringify(this.fonograma_individuo_parcial))
                    );            
                    this.fonograma_individuo_parcial = { tipo: "" };
                }else{
                    erro_isrc="Por favor digite um CPF válido."
                    this.$refs.modal.show(
                    "Informações do ISRC",
                    erro_isrc,
                    "Entendi"
                );
                }
            })
            
            //----------------------------------------
          
            
            
        },
        continuar_adicionar_informacoes_isrc(track){
            
            if (track.isrc_info.participantes.length===0) {
                track.isrc_info.participantes = [];
                track.isrc_info.participantes.push({
                    fullname: "MK Edições Musicais LTDA",
                    br_cpf_cnpj: "03.199.269/0001-37",
                    alias: "MK Edições",
                    tipo: { cat: "PRODUTOR FONOGRÁFICO", cod: "PF" },
                    deletable:false
                });
                if(track.feat_artists.length > 0){
                    this.trackItem.feat_artists.map( feat_artists =>{
                        track.isrc_info.participantes.push({
                            fullname: feat_artists.fullname,
                            br_cpf_cnpj: feat_artists.br_cpf_cnpj,
                            alias: feat_artists.alias,
                            tipo: { cat: "INTERPRETE", cod: "I" },
                            deletable:true
                        })
                    })
    
                }
                let person = JSON.parse(
                    JSON.stringify(this.$store.getters.user.myself)
                );
                if(this.artist.members != undefined && Array.isArray(this.artist.members)){
                    this.artist.members.map( e =>{
                        track.isrc_info.participantes.push({
                        fullname: e.name + " " + e.lastname,
                        br_cpf_cnpj: e.cpf,
                        alias: e.name + " " + e.lastname,
                        tipo: { cat: "PRODUTOR FONOGRÁFICO", cod: "PF" }
                    });
                    });
                    this.artist.members.map( e =>{
                        track.isrc_info.participantes.push({
                        fullname: e.name + " " + e.lastname,
                        br_cpf_cnpj: e.cpf,
                        alias: e.name + " " + e.lastname,
                        tipo:  { cod: "I", cat: "INTERPRETE" }
                    });
                    });
                }
                else{
                    track.isrc_info.participantes.push({
                        fullname: person.name + " " + person.lastname,
                        br_cpf_cnpj: person.cpf,
                        alias: person.name + " " + person.lastname,
                        tipo: { cat: "PRODUTOR FONOGRÁFICO", cod: "PF" }
                    });
                    track.isrc_info.participantes.push({
                        fullname: person.name + " " + person.lastname,
                        br_cpf_cnpj: person.cpf,
                        alias: person.name + " " + person.lastname,
                        tipo:  { cod: "I", cat: "INTERPRETE" }
                    });
                }
            }
            this.$forceUpdate(this.tracks)
            this.btn_adicionar_info=true;
        },
        delete_participante_member(item, track){
            
            var new_list = track.isrc_info.participantes.filter( e =>{
                if( (e.fullname) == (item.fullname) && (e.tipo == item.tipo) ){
                    return false;
                }
                return true;
            });
            track.isrc_info.participantes = new_list;
        },
        edit_participante_member(item, track){
            this.fonograma_individuo_parcial = item;
            this.delete_participante_member(item, track);
            this.$vuetify.goTo(".target_isrc_info")
        },
        check_set_feat_in_isrc_info(){
            if(this.trackItem.own_isrc == 1){
                return;
            }
            if(this.trackItem.isrc_info.participantes.length === 0){
                return;
            }

           if( this.trackItem.feat_artists.length >= 0){
               this.trackItem.feat_artists.map( feat=>{
                   let feat_is_in_isrc_info = false;
                   this.trackItem.isrc_info.participantes.map( participante =>{
                       if(feat.br_cpf_cnpj == participante.br_cpf_cnpj){
                           feat_is_in_isrc_info = true;
                       }
                   })
                   if(!feat_is_in_isrc_info){
                        feat.tipo = {cod:'I',cat:'INTERPRETE'};
                        this.trackItem.isrc_info.participantes.push(JSON.parse( JSON.stringify(feat) ) );
                    }
               })
           }
        },
        adicionar_feat_to_track(){
            if(!this.dialog_feat_obj.br_cpf_cnpj || !this.dialog_feat_obj.fullname || !this.dialog_feat_obj.alias ){
                var erro_isrc="Todos os campos são obrigatórios."
                    this.$refs.modal.show(
                    "Atenção",
                    erro_isrc,
                    "Entendi");
                return;
            }
            valida_cpf(this.dialog_feat_obj.br_cpf_cnpj).then(e=>{

                if(e.valid){
                    this.trackItem.feat_artists.push(JSON.parse( JSON.stringify(this.dialog_feat_obj)));
                    this.dialog_feat_obj={};
                    this.dialog_adicionar_feat = false;
                    this.check_set_feat_in_isrc_info();
                }else{
                    var erro_isrc="Por favor digite um CPF válido."
                    this.$refs.modal.show(
                    "Informações do ISRC",
                    erro_isrc,
                    "Entendi");
                }

            })
            
        },
    },
    beforeRouteLeave(to, from, next) {
        const answer = true; //window.confirm('Você tem alterações que não foram salvas. Tem certeza que quer sair?')
        if (answer) {
            next();
        } else {
            next(false);
        }
    }
};
</script>

<style scopped>
@media screen and (max-width: 700px) {
    aside {
        width: 100% !important;
    }
}
</style>